import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.css';
import FooterLogo from "../../utils/images/footer-logo.svg";
import FacebookIcon from "../../utils/images/facebook-icon.svg";
import InstagramIcon from "../../utils/images/instagram-icon.svg";
import tiktokblack from "../../utils/images/tiktok-black.svg";
import callicon from "../../utils/images/call-icon.svg";
import mailicon from "../../utils/images/mail-icon.svg";
import { config as appConfig } from "../../config/config";



function Footer(props) {
    const API_BASE = appConfig.localApiUrl;
    const ASSET_BASE = API_BASE.replace(/\/api\/?$/, "");

    const cfg = props?.configData || {};
    const [isLoading, setIsLoading] = useState(true);
    // console.log("Footer config data  -----------:>", cfg);
    // console.log("logo url:", cfg?.Merchant_footer_logo ? `${ASSET_BASE}${cfg.Merchant_footer_logo}` : FooterLogo);

    // Simulate loading for skeleton
    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 500);
        return () => clearTimeout(timer);
    }, []);

    // Skeleton Loader Component
    const FooterSkeleton = () => (
        <div className="footer footer-skeleton">
            <div className="container">
                <div className="footer-row">
                    <div className="footer-logo">
                        <div className="skeleton-box skeleton-footer-logo"></div>
                    </div>
                    <div className="footer-links">
                        <div className="footer-text">
                            <ul>
                                <div className="skeleton-box skeleton-title"></div>
                                <li><div className="skeleton-box skeleton-link"></div></li>
                                <li><div className="skeleton-box skeleton-link"></div></li>
                            </ul>
                        </div>
                    </div>
                    <div className="footer-links child-2">
                        <div className="footer-text">
                            <ul>
                                <div className="skeleton-box skeleton-title"></div>
                                <li><div className="skeleton-box skeleton-link-sm"></div></li>
                                <li><div className="skeleton-box skeleton-link-sm"></div></li>
                                <li><div className="skeleton-box skeleton-link-sm"></div></li>
                            </ul>
                        </div>
                    </div>
                    <div className="footer-links">
                        <div className="footer-text">
                            <ul>
                                <div className="skeleton-box skeleton-title"></div>
                                <li><div className="skeleton-box skeleton-link-sm"></div></li>
                                <li><div className="skeleton-box skeleton-link-sm"></div></li>
                            </ul>
                        </div>
                    </div>
                    <div className="footer-links child-3">
                        <div className="footer-icon">
                            <ul>
                                <li><div className="skeleton-box skeleton-icon"></div></li>
                                <li><div className="skeleton-box skeleton-icon"></div></li>
                                <li><div className="skeleton-box skeleton-icon"></div></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );


    return (
        <app-footer>
            {isLoading ? <FooterSkeleton /> : <div className="footer">
                <div className="container">
                    <div className="footer-row">
                        <div className="footer-logo">
                            <a href="/">
                                <img
                                    src={cfg?.Merchant_footer_logo ? `${ASSET_BASE}${cfg.Merchant_footer_logo}` : FooterLogo}
                                    alt="header-logo"
                                />
                            </a>
                            {/* <img src={FooterLogo} alt="" /></a> */}
                        </div>
                        <div className="footer-links">
                            <div className="footer-text">

                                <ul>
                                    <h3>Get in touch</h3>
                                    <li>
                                        <a href={`tel:${cfg && cfg?.Phone_Number}`}>
                                            <img src={callicon} />
                                            {cfg && cfg?.Phone_Number}
                                        </a>
                                    </li>
                                    <li>
                                        <a href={`mailto:${cfg && cfg?.Email}`}>
                                            <img src={mailicon} />
                                            {cfg && cfg?.Email}
                                        </a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                        <div className="footer-links child-2">
                            <div className="footer-text">
                                <ul>
                                    <h3>Work with us</h3>
                                    <li>
                                        <a
                                            href={`${cfg?.User_Site_url || ""}/influencers`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Influencers
                                        </a>
                                    </li>
                                    {/* <li>Bloggers</li>
                                    <li>Agencies</li> */}
                                </ul>
                            </div>
                        </div>

                        <div className="footer-links">
                            <div className="footer-text">
                                <ul>
                                    <h3>More</h3>
                                    <li>
                                        <a href="/privacy-policy">
                                            Privacy Policy
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/terms">
                                            Terms & Conditions
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/get-in-touch">
                                            Connect with Support
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="footer-links child-3">
                            <div className="footer-icon">
                                <ul>
                                    <li><a href={cfg.Tiktok}><img src={tiktokblack} alt="" /></a></li>
                                    <li><a href={cfg.Facebook}><img src={FacebookIcon} alt="" /></a></li>
                                    <li><a href={cfg.Instagram}><img src={InstagramIcon} alt="" /></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </app-footer>
    )

};



export default Footer;